import { useIntl } from 'react-intl';
import { Toggle, Tooltip } from '@ets/design-system';

import { navigateToUserSettings } from 'router/navigation';
import { useDispatch, useSelector } from '_common/hooks';
import { setSelectedTab } from '_common/redux/TabMenuSlice';
import { selectIsIEnvision } from 'App/redux/appSlice';

type SettingsProps = {
  testId: string;
  closePopover: () => void;
};

const Settings = ({ testId, closePopover }: SettingsProps) => {
  const isiEnvision = useSelector(selectIsIEnvision);
  const dispatch = useDispatch();
  const intl = useIntl();

  const handleGoToSettings = () => {
    dispatch(
      setSelectedTab({ menuId: 'userSettingsPage', selectedTab: 'user-preferences-notifications' }),
    );
    navigateToUserSettings();
    closePopover();
  };

  return (
    <Tooltip
      content={intl.formatMessage({ id: 'GO_TO_NOTIFICATION_SETTINGS' })}
      placement="bottom"
      visible={!isiEnvision}
      testId={`${testId}`}
    >
      <Toggle
        size="m"
        variant="link"
        iconProps={{ icon: 'gear' }}
        onClick={handleGoToSettings}
        testId={testId}
        disabled={isiEnvision}
      />
    </Tooltip>
  );
};

export default Settings;
